import React, {Component} from 'react';
import DialogRow from './DialogRow';
import {renderSignature} from '../shared/imageFunctions';

class DialogRegisterLogDetail extends Component {

    render() {
        const {
            data
        } = this.props;

        return (
            <div className="reports-custom-table-container">
                {data.seq &&
                <DialogRow label="ID" value={data.seq}/>
                }
                {data.version &&
                <DialogRow label="Version" value={data.version}/>
                }
                {data.register_id &&
                <DialogRow label="Register" value={data.register_id}/>
                }
                {data.device_id &&
                <DialogRow label="Device" value={data.device_id}/>
                }
                {data.date_string &&
                <DialogRow label="Modified" value={data.date_string}/>
                }
                {data.type &&
                <DialogRow label="Type" value={data.type}/>
                }
                {data.till_open &&
                <DialogRow label="Open Till Amount" value={data.till_open}/>
                }
                {data.till_close &&
                <DialogRow label="Close Till Amount" value={data.till_close}/>
                }
                {data.close_cash_reported &&
                <DialogRow label="Close Cash Reported" value={data.close_cash_reported}/>
                }
                {data.sales_cash &&
                <DialogRow label="Cash Sales" value={data.sales_cash}/>
                }
                {data.sales_credit &&
                <DialogRow label="Credit Sales" value={data.sales_credit}/>
                }
                {data.credits_cash &&
                <DialogRow label="Cash Refunds" value={data.credits_cash}/>
                }
                {data.credits_credit &&
                <DialogRow label="Credit Refunds" value={data.credits_credit}/>
                }
                {data.number_of_payments_cash &&
                <DialogRow label="Number of Cash Sales" value={data.number_of_payments_cash}/>
                }
                {data.number_of_payments_credit &&
                <DialogRow label="Number of Credit Sales" value={data.number_of_payments_credit}/>
                }
                {data.number_of_credits_cash &&
                <DialogRow label="Number of Cash Refunds" value={data.number_of_credits_cash}/>
                }
                {data.number_of_credits_credit &&
                <DialogRow label="Number of Credit Refunds" value={data.number_of_credits_credit}/>
                }
                {data.number_of_discounts &&
                <DialogRow label="Number of Discounts" value={data.number_of_discounts}/>
                }
                {data.number_of_withdrawals &&
                <DialogRow label="Number of Withdrawals" value={data.number_of_withdrawals}/>
                }
                {data.withdrawals &&
                <DialogRow label="Withdrawals" value={data.withdrawals}/>
                }
                {data.register_open_string &&
                <DialogRow label="Open Date" value={data.register_open_string}/>
                }
                {data.register_close_string &&
                <DialogRow label="Close Date" value={data.register_close_string}/>
                }
                {data.signature &&
                <DialogRow label="Signature" value={renderSignature(data.signature)}/>
                }
            </div>
        );
    }
}

export default DialogRegisterLogDetail;



// WEBPACK FOOTER //
// ./src/Fuse/components/DialogRegisterLogDetail.js